/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React from 'react';
import { BulletinFollowupTypes } from 'store/modules/bulletins_store/types';
import FollowupHeader from 'components/atoms/followup_header';
import MapLink from 'components/atoms/map_link';
import HighlightedText from 'components/atoms/highlighted_text';
import moment from 'moment';
import { FollowupData } from 'store/modules/followup_store/types';
import { Container, Text } from './styles';

interface FollowupItemProps {
  followup: BulletinFollowupTypes | FollowupData;
  isChecked?: boolean;
  followupIndex?: number;
  toggleSelected?: (id: number, updateAll?: boolean) => void;
  followupKeywords?: Array<string>;
  source?: 'bulletin' | 'followupOnlineSearch';
}

const FollowupItem = (props: FollowupItemProps) => {
  const {
    followup,
    isChecked = false,
    followupIndex = 0,
    toggleSelected = () => {},
    followupKeywords = [],
    source = 'bulletin',
  } = props;

  return (
    <Container className="row">
      <div className="col-12 p-0">
        <div
          className={`card shadow bidding mb-5 ${isChecked ? 'bidding_selected' : 'd-print-none'}`}
        >
          <FollowupHeader
            followupId={
              followup.followup_id ? followup.followup_id.toString() : followup.id.toString()
            }
            biddingIndex={followupIndex}
            isChecked={isChecked}
            followupBiddingId={followup.bidding_id}
            toggleSelected={toggleSelected}
          />
          <div className="card-body p-3">
            <div className="row bidding-info mb-2">
              <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">Objeto</div>
              {source === 'bulletin' && (
                <HighlightedText
                  key={followup.followup_id}
                  className="col-md-11"
                  termsList={followupKeywords}
                  text={followup.objeto}
                />
              )}
              {source === 'followupOnlineSearch' && (
                <Text className="col-md-11" dangerouslySetInnerHTML={{ __html: followup.objeto }} />
              )}
            </div>
            <div className="row bidding-info mb-2">
              <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">Edital</div>
              <div className="col-md-2 text-secondary">{followup.edital || '-'}</div>

              <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title mt-2 mt-md-0">
                Nº Conlicitação
              </div>
              <div className="col-md-2 text-secondary">{followup.followup_id}</div>
              <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title mt-2 mt-md-0">
                Processo
              </div>
              <div
                className="col-md-3"
                dangerouslySetInnerHTML={{ __html: followup.processo || '-' }}
              />
            </div>
            <div className="row bidding-info mb-2">
              <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">Cidade</div>
              <div className="col-md-6">
                {followup.orgao_cidade} -{' '}
                <span className="bidding-info-state">{followup.orgao_estado}</span>
                <MapLink
                  address={`ÓRGÃO ENDEREÇO INDISPONÍVEL ${followup.orgao_cidade} ${followup.orgao_estado}`}
                  source={source}
                />
              </div>
              <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title">
                Data Fonte
              </div>
              <div className="col-md-3 text-secondary">
                {moment(followup.data_fonte).format('L') || '-'}
              </div>
            </div>
            <div className="row bidding-info mb-2">
              <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">Órgão</div>

              <div className="col-md-11">{followup.public_body?.nome || '-'}</div>
            </div>
            <div className="row bidding-info mb-2">
              <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                Síntese
              </div>

              {source === 'bulletin' && (
                <HighlightedText
                  className="col-md-11"
                  termsList={followupKeywords}
                  text={followup.sintese}
                />
              )}
              {source === 'followupOnlineSearch' && (
                <Text
                  className="col-md-11"
                  dangerouslySetInnerHTML={{ __html: followup.sintese }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FollowupItem;
